<template>
  <div class="page">
    <el-row :gutter="20">
      <el-col :span="10">
        <div class="card">
          <div class="cardtitle">单位信息</div>
          <div style="background: white;display: flex;">
            <el-image class="container" :src="require('@/assets/img/icon_ar.png')" fit="contain" style="width: 128px;height: 128px;padding: 10px;display: block;" />
            <div style="flex: 1;">
              <div style="border-bottom: 1px solid gainsboro;padding: 12px 20px;display: flex;align-items: center;">
                <div style="flex: 1;">单位名称：{{tenantinfo.tenantName}}</div>
                <el-button v-if="tenantlist.length>1" @click="changtenant = true" style="background-color: #05C15F;border: 0;" type="danger">切换</el-button>
              </div>
              <div style="border-bottom: 1px solid gainsboro;padding: 12px 20px;">单位编号：{{tenantinfo.tenantType==2?tenantinfo.alterTenantId:tenantinfo.tenantId}}</div>
              <!-- <div style="border-bottom: 1px solid gainsboro;padding: 12px 20px;">单位类型：{{tenantinfo.tenantType==2?branchlist[0].branchFullName+'内部用户':'助手单位'}}</div> -->
              <div style="padding: 12px 20px;">创建日期：{{tenantinfo.createdTime}}</div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="cardtitle" style="padding: 0 20px;display: flex;align-items: center;">
            <div style="padding: 12px 0;flex: 2;">登录员工：{{userinfo.userName}} {{  userinfo.telNo || userinfo.userCode}}</div>
            <el-button v-if="!tenantuserinfo.changePasswordForbid" style="background-color: #05C15F;border: 0;" type="danger" @click="updpass">修改密码</el-button>
          </div>
          <div style="background: white;">
            <div style="border-bottom: 1px solid gainsboro;padding: 23px 20px;display: flex;align-items: center;">
              <el-image class="container" :src="userinfo.wechatAvater" fit="contain" style="width: 150px;height: 150px;display: block;">
                <div slot="error" class="image-slot">
                  <el-image class="container" :src="require('@/assets/img/shipping.png')" fit="contain" style="width: 150px;height: 150px;display: block;" />
                </div>
              </el-image>
              <div v-if="userinfo.wechatUsers && userinfo.wechatUsers.length" style="flex: 1;height: 150px;overflow: auto;">
                <div v-for="(item, key) in userinfo.wechatUsers" :key="key" class="wxlist" style="padding: 11px 2px;">
                  <el-image class="container" :src="item.wechatAvatar" fit="contain" style="width: 28px;height: 28px;vertical-align: middle;" />
                  <span style="display: inline-block;vertical-align: middle;width: 220px;padding-left: 5px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{item.mpNickName || item.wechatName}}</span>
                  <i class="el-icon-close close" @click="unbanld(item)" style="font-size: 20px;vertical-align: middle;float: right;line-height: 28px;" />
                </div>
              </div>
              <div v-else style="flex: 1;text-align: center;line-height: 22px;">
                <div>关注发货助手公众号</div>
                <div>选择接收你关注的信息</div>
              </div>
            </div>
            <!-- 订阅服务商消息通知:0.收货确认通知,1.欠费提醒,2.报价通知,3.港前问题,4.港后问题,5.转运轨迹问题,7,收货问题；11，通知公告,12订单跟踪提醒 -->
			<div v-if="false">
            <div style="border-bottom: 1px solid gainsboro;padding: 12px 20px;display: flex;align-items: center;">
              <div style="flex: 1;">
                <div style="line-height: 1.5;">收货确认通知</div>
                <div style="line-height: 1.3;color:#909399;font-size:12px;">服务商对你收货完成后，你会收到通知</div>
              </div>
              <el-switch :value='numtotitflog(tenantuserinfo.bizMessageSub,0)' @click.native='changebizMessageSub(0)' active-color="#13ce66"></el-switch>
            </div>
            <div style="border-bottom: 1px solid gainsboro;padding: 12px 20px;display: flex;align-items: center;">
              <div style="flex: 1;">
                <div style="line-height: 1.5;">欠费通知</div>
                <div style="line-height: 1.3;color:#909399;font-size:12px;">服务商把你的账户标识为欠费时，你会收到通知</div>
              </div>
              <el-switch :value='numtotitflog(tenantuserinfo.bizMessageSub,1)' @click.native='changebizMessageSub(1)' active-color="#13ce66"></el-switch>
            </div>
            <div style="border-bottom: 1px solid gainsboro;padding: 12px 20px;display: flex;align-items: center;">
              <div style="flex: 1;">
                <div style="line-height: 1.5;">客户跟踪提醒</div>
                <div style="line-height: 1.3;color:#909399;font-size:12px;">服务商发布公告时，接收提醒</div>
              </div>
              <el-switch :value='numtotitflog(tenantuserinfo.bizMessageSub,11)' @click.native='changebizMessageSub(11)' active-color="#13ce66"></el-switch>
            </div>
            <div style="padding: 12px 20px;display: flex;align-items: center;">
              <div style="flex: 1;">
                <div style="line-height: 1.5;">订单跟踪提醒</div>
                <div style="line-height: 1.3;color:#909399;font-size:12px;">接收服务商批量通知的运单跟进</div>
              </div>
              <el-switch :value='numtotitflog(tenantuserinfo.bizMessageSub,12)' @click.native='changebizMessageSub(12)' active-color="#13ce66"></el-switch>
            </div>
			</div>
          </div>
          <div v-if="false" style="margin-top: 8px;background: white;">
            <div style="border-bottom: 1px solid gainsboro;padding: 12px 20px;">
              <div style="line-height: 1.5;">快件异常提醒</div>
            </div>
            <div  style="padding: 0 0 0 20px;">
              <div style="border-bottom: 1px solid gainsboro;padding: 12px 20px;display: flex;align-items: center;">
                <div style="flex: 1;">
                  <div style="line-height: 1.5;">接收收货问题通知</div>
                </div>
                <el-switch :value='numtotitflog(tenantuserinfo.bizMessageSub,7)' @click.native='changebizMessageSub(7)' active-color="#13ce66"></el-switch>
              </div>
              <!-- <div style="border-bottom: 1px solid gainsboro;padding: 12px 20px;display: flex;align-items: center;">
                <div style="flex: 1;">
                  <div style="line-height: 1.5;">接收港前问题</div>
                </div>
                <el-switch :value='numtotitflog(tenantuserinfo.bizMessageSub,3)' @click.native='changebizMessageSub(3)' active-color="#13ce66"></el-switch>
              </div>
              <div style="border-bottom: 1px solid gainsboro;padding: 12px 20px;display: flex;align-items: center;">
                <div style="flex: 1;">
                  <div style="line-height: 1.5;">接收港后问题</div>
                </div>
                <el-switch :value='numtotitflog(tenantuserinfo.bizMessageSub,4)' @click.native='changebizMessageSub(4)' active-color="#13ce66"></el-switch>
              </div> -->
              <div style="padding: 12px 20px;display: flex;align-items: center;">
                <div style="flex: 1;">
                  <div style="line-height: 1.5;">接收转运轨迹问题</div>
                </div>
                <el-switch :value='numtotitflog(tenantuserinfo.bizMessageSub,5)' @click.native='changebizMessageSub(5)' active-color="#13ce66"></el-switch>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="cardtitle" style="padding: 0 20px;display: flex;align-items: center;">
            <div style="padding: 12px 0;flex: 2;">单位成员</div>
            <el-button style="background-color: #05C15F;border: 0;" type="danger" v-if="tenantuserinfo.sysUser" @click="adduser">添加</el-button>
          </div>
          <!-- <div style="background: white;height: 400px;overflow: auto;">
            <div v-for="(item,k) in mployeelist" :key="k" style="border-bottom: 1px solid gainsboro;padding: 12px 20px;display: flex;">
              <div style="width: 30px;">
                <font-awesome-icon v-if="item.wechatUnionId" :icon="['fab', 'weixin']" style="margin-right: 12px;color: rgb(42,161,69)" />
              </div>
              <div style="flex: 1;">{{item.userName}}：</div>
              <div style="flex: 1;">{{item.telNo || item.userCode}}</div>
              <div style="flex: 1;text-align: right;">{{item.roleName}}</div>
              <div style="width: 60px;color: gray;text-align: right;">
                <font-awesome-icon :icon="['fas', 'key']" v-if="tenantuserinfo.sysUser && item.userCode != userinfo.userCode" @click="reloadpwd(item)" />
                <font-awesome-icon :icon="['fas', 'trash-alt']" style="margin-left: 12px;" v-if="tenantuserinfo.sysUser && item.userCode != userinfo.userCode" @click="delectuser(item)" />
              </div>
            </div>
          </div> -->
          <div style="background: white;max-height: 400px;overflow: auto;">
            <div v-for="(item,k) in tenanuserlist" :key="k" style="border-bottom: 1px solid gainsboro;padding: 12px 20px;display: flex;">
              <div style="width: 30px;">
                <font-awesome-icon v-if="item.wechatUsers && item.wechatUsers.length" :icon="['fab', 'weixin']" style="margin-right: 12px;color: rgb(42,161,69)" />
              </div>
              <div style="flex: 1;">{{item.userName}}：</div>
              <div style="flex: 1;">{{item.telNo || item.userCode}}</div>
              <div style="flex: 0.5;text-align: right;">{{item.roleName}}</div>
              <div style="width: 106px;color: gray;text-align: right;">
                <span v-if="item.sysUser" style="color:blue;">主号
                  <el-tooltip v-if="item.sysUser" content="登录主账号，可对员工账号：添加、删除、修改密码" placement="bottom" effect="light">
                    <i class="el-icon-question" style="color:#f56c6c;"></i>
                  </el-tooltip>
                </span>
                <font-awesome-icon :icon="['fas', 'key']" v-if="tenantuserinfo.sysUser && item.userCode != userinfo.userCode" @click="reloadpwd(item)" />
                <font-awesome-icon :icon="['fas', 'trash-alt']" style="margin-left: 12px;" v-if="tenantuserinfo.sysUser && item.userCode != userinfo.userCode" @click="delectuser(item)" />
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="card">
          <div class="cardtitle">服务商余额</div>
          <div style="background: white;">
            <template v-for="(item,k) in branchlist">
              <div :key="k" v-if="k<3" style="border-bottom: 1px solid gainsboro;padding: 12px 20px;display: flex;">
                <div style="flex: 1;">{{item.branchFullName}}：</div>
                <div style="flex: 1;">{{item.createdTime}}</div>
                <div style="flex: 1;color: coral;text-align: right;" @click="goBill(item)">{{item.providerBalance}}
                  <font-awesome-icon icon="chevron-right" style="margin-left: 12px;" />
                </div>
              </div>
            </template>
            <div style="padding: 12px 20px;display: flex;justify-content: flex-end;">
              <el-button style="padding: 0" type="text">更多>></el-button>
            </div>
          </div>
        </div> -->
      </el-col>
      <el-col :span="14">
        <template v-if="noticeformelist.length">
          <template v-for="(item,index) in noticeformelist">
            <div class="notice" v-if="index<10" @click="goSpace(item)" :key="item.noticeId" style="width: 100%;max-height: 400px;overflow: hidden;padding: 20px;background-color: #fff;box-shadow: 0 2px 4px 0 rgb(0 0 0 / 12%), 0 0 6px 0 rgb(0 0 0 / 4%);position: relative;">
              <div style="border-bottom: 1px solid #f2f2f2;line-height: 36px;height: 36px;margin-bottom: 10px;">
                <el-image class="container" :src="require('@/assets/img/icon_ar.png')" fit="contain" style="width: 36px;height: 36px;vertical-align: top;" />
                <span style="font-size: 18px;font-weight: bold;margin-left: 15px;">{{item.noticeTitle}}</span>
                <span style="font-size: 12px;float: right;margin-left: 15px;">{{item.publishTime}}</span>
                <span style="font-size: 12px;float: right;margin-left: 15px;">{{item.publisherName}}</span>
              </div>
              <template v-if="item.attachment">
                <el-table :data="JSON.parse(item.attachment)" :show-header='false' style="margin-bottom: 18px;color: #949494;font-size:18px !important;">
                  <el-table-column width="50">
                    <template><i class="el-icon-paperclip" style="font-size:40px !important;"></i></template>
                  </el-table-column>
                  <el-table-column prop="name"></el-table-column>
                  <el-table-column prop="size">
                    <template slot-scope="{row}">
                      <span>{{row.size/1024/1024>1?(row.size/1024/1024).toFixed(2)+'M':row.size/1024>1?(row.size/1024).toFixed(2)+'KB':'小于1KB'}}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
              <div v-html="item.noticeContent"></div>
              <div style="position: absolute;top: 380px;left: 0;width: 100%;height: 20px;background: linear-gradient(transparent,#f6f8f8);"></div>
            </div>
          </template>
        </template>
        <el-empty v-else description="暂无公告"></el-empty>
      </el-col>
    </el-row>
    <el-dialog title="切换单位" :visible.sync="changtenant" width="600px">
      <div style="display: flex;justify-content: space-evenly;">
        <div v-for="(gstenant,k) in tenantlist" :key="k" @click="changtent(gstenant)" style="width: 128px;height: 158px;text-align: center;">
          <el-image class="container" :src="require('@/assets/img/icon_ar.png')" fit="contain" style="width: 128px;height: 128px;padding: 10px;display: block;" />
          {{gstenant.tenantName}}
        </div>
      </div>
    </el-dialog>
    <el-dialog title="修改密码" :visible.sync="passVisible" width="600px">
      <el-form :model="pass" label-width="120px" :rules="rules" ref="ruleForm">
        <el-form-item label="输入原密码" prop="oldpassword">
          <el-input type="password" v-model="pass.oldpassword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="pass.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkpass">
          <el-input type="password" v-model="pass.checkpass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmitupdpass">确认修改</el-button>
          <el-button @click="passVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="添加员工" :visible.sync="userVisible" width="600px">
      <el-form :model="form" label-width="80px" :rules="formrules" ref="form">
        <el-row>
          <el-col :span="8">
            <el-form-item label="登录编号">
              <el-input v-model="form.tenantId" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="员工编号" prop="userCode">
              <el-input v-model="form.userCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="密码" prop="password">
              <el-input v-model="form.password"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="员工姓名" prop="userName">
          <el-input v-model="form.userName"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="form.remark"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmitadduser">立即添加</el-button>
          <el-button @click="userVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :title="optype==1?'重置密码':'删除用户'" :visible.sync="reloaddelectVisible" width="600px">
      <el-alert :title="optype==1?'密码验证通过，将重置该成员账户密码':'密码验证通过，将删除该成员账户'" type="warning" :closable="false"></el-alert>
      <el-form label-position="top" label-width="80px" style="margin-top: 20px;">
        <el-form-item :label="'身份安全验证,请输入管理员:   '+userinfo.userName+'   '+(userinfo.telNo || userinfo.userCode)+'账户密码：'">
          <el-input type="password" v-model="password" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="reloaddelectVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmitreloadpwss(reloadpassword)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'Home',
  data() {
    var validatePass = (rule, value, callback) => {
      this.$refs.ruleForm.validateField('checkpass')
      callback()
    }
    var validatePass2 = (rule, value, callback) => {
      if (value != this.pass.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      tenantinfo: JSON.parse(localStorage.getItem('tenantinfo')),
      tenantlist: JSON.parse(localStorage.getItem('tenantlist')),
      userinfo: JSON.parse(localStorage.getItem('userinfo')),
      tenantuserinfo: JSON.parse(localStorage.getItem('tenantuserinfo')),
      branchlist: JSON.parse(localStorage.getItem('branchlist')),
      mployeelist: JSON.parse(localStorage.getItem('mployeelist')),
      tenanuserlist: JSON.parse(localStorage.getItem('tenanuserlist')),
      changtenant: false,
      passVisible: false,
      pass: {},
      rules: {
        oldpassword: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ],
        checkpass: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validatePass2, trigger: 'blur' }
        ]
      },
      userVisible: false,
      form: {},
      formrules: {
        userCode: [{ required: true, message: '请输入用户编号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入户初始密码', trigger: 'blur' }],
        userName: [{ required: true, message: '请输入用户名称', trigger: 'blur' }]
      },
      reloaddelectVisible: false,
      optype: 1,
      password: '',
      reloadpassword: {},
      noticeformelist: []
    }
  },
  mounted() {
    this.getnoticeformelist()
  },
  methods: {
    async getnoticeformelist() {
      let params = { pageNum: 1, pageSize: 100 }
      let res = await this.$api.noticeformelist(params)
      this.noticeformelist = res.list
    },
    goSpace(item) {
      this.$router.push({ name: 'Space', params: { notice: item.noticeId } })
    },
    async changtent(crrtenant) {
      try {
        this.loading = true
        const tenantinfo = await this.$api.gettenantinfo(crrtenant.tenantId)
        const tenanuserlist = await this.$api.getTenanUserList(crrtenant.tenantId)
        const tenantuserinfo = await this.$api.gettenantuserinfo(crrtenant.tenantId, this.userinfo.userCode)
        const userinfo = await this.$api.getuserinfo(crrtenant.tenantId, this.userinfo.userCode)
        const branchinfoRes = await this.$api.getbranchinfo(crrtenant.tenantId)
        let branchlist = branchinfoRes.list.filter((branch) => branch.branchCode != tenantinfo.tenantId) // 过滤自己单位
        const mployeelist = await this.$api.getemployeeList(crrtenant.tenantId)
        localStorage.setItem('tenantId', crrtenant.tenantId)
        localStorage.setItem('tenantinfo', JSON.stringify(tenantinfo))
        localStorage.setItem('tenanuserlist', JSON.stringify(tenanuserlist))
        localStorage.setItem('userinfo', JSON.stringify(userinfo))
        localStorage.setItem('tenantuserinfo', JSON.stringify(tenantuserinfo))
        localStorage.setItem('branchlist', JSON.stringify(branchlist))
        localStorage.setItem('mployeelist', JSON.stringify(mployeelist))
        location.reload()
      } catch (error) {
        this.$message.warning(error)
      } finally {
        this.loading = false
      }
    },
    updpass() {
      this.passVisible = true
      this.pass = {}
    },
    onSubmitupdpass() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (!valid) return
        try {
          this.loading = true
          let username = this.userinfo.telNo || this.userinfo.userCode
          await this.$api.userlogin(username, this.pass.oldpassword)
          this.userinfo.password = this.pass.password
          await this.$api.updUser(this.userinfo)
          localStorage.removeItem('x-auth-token')
          localStorage.removeItem('tenantlist')
          localStorage.removeItem('tenantId')
          localStorage.removeItem('tenantinfo')
          localStorage.removeItem('tenanuserlist')
          localStorage.removeItem('userinfo')
          localStorage.removeItem('tenantuserinfo')
          localStorage.removeItem('branchlist')
          localStorage.removeItem('mployeelist')
          localStorage.removeItem('savebranch')
          localStorage.removeItem('timeStamp')
          this.passVisible = false
          this.$alert('你的账户密码已修改，将自动退出登录', '修改成功', {
            confirmButtonText: '确定',
            callback: () => {
              this.$router.replace('/login')
            }
          })
        } catch (error) {
          this.$message.warning(error)
        } finally {
          this.loading = false
        }
      })
    },
    adduser() {
      this.userVisible = true
      this.form = {
        tenantId: this.userinfo.sysUser ? this.tenantinfo.tenantId : this.tenantinfo.alterTenantId
      }
    },
    async onSubmitadduser() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return
        try {
          this.loading = true
          let user = { userCode: this.form.tenantId + '-' + this.form.userCode, userName: this.form.userName, password: this.form.password }
          await this.$api.addUser(user)
          let tenantuser = { tenantId: this.tenantinfo.tenantId, userCode: this.form.tenantId + '-' + this.form.userCode, userName: this.form.userName, remark: this.form.remark }
          await this.$api.addTenantuser(tenantuser)
          const tenanuserlist = await this.$api.getTenanUserList(this.tenantinfo.tenantId)
          const mployeelist = await this.$api.getemployeeList(this.tenantinfo.tenantId)
          localStorage.setItem('tenanuserlist', JSON.stringify(tenanuserlist))
          localStorage.setItem('mployeelist', JSON.stringify(mployeelist))
          this.tenanuserlist = JSON.parse(localStorage.getItem('tenanuserlist'))
          this.mployeelist = JSON.parse(localStorage.getItem('mployeelist'))
          this.$message.success('添加用户成功')
          this.userVisible = false
          this.$alert('', '添加用户成功', {
            confirmButtonText: '确定'
          })
        } catch (error) {
          this.$message.warning('添加用户失败')
        } finally {
          this.loading = false
        }
      })
    },
    reloadpwd(item) {
      this.optype = 1
      this.reloaddelectVisible = true
      this.password = ''
      this.reloadpassword = item
    },
    delectuser(item) {
      this.optype = 2
      this.reloaddelectVisible = true
      this.password = ''
      this.reloadpassword = item
    },
    async onSubmitreloadpwss(item) {
      if (!this.password) return this.$message.warning('请验证当前账户密码')
      try {
        this.loading = true
        let username = this.userinfo.telNo || this.userinfo.userCode
        await this.$api.userlogin(username, this.password)
        if (this.optype == 1) {
          item.password = '123456'
          await this.$api.updUser(item)
          this.$alert('', '重置用户密码成功', {
            confirmButtonText: '确定'
          })
        } else {
          await this.$api.delUser(item)
          const tenanuserlist = await this.$api.getTenanUserList(this.tenantinfo.tenantId)
          const mployeelist = await this.$api.getemployeeList(this.tenantinfo.tenantId)
          localStorage.setItem('tenanuserlist', JSON.stringify(tenanuserlist))
          localStorage.setItem('mployeelist', JSON.stringify(mployeelist))
          this.tenanuserlist = JSON.parse(localStorage.getItem('tenanuserlist'))
          this.mployeelist = JSON.parse(localStorage.getItem('mployeelist'))
          this.$alert('', '删除用户成功', {
            confirmButtonText: '确定'
          })
        }
        this.reloaddelectVisible = false
      } catch (error) {
        this.$message.warning('操作失败')
      } finally {
        this.loading = false
      }
    },
    // 下载文件
    async downloadAttachment(row) {
      this.$notify.info('请稍后')
      Vue.prototype.$qiniu = await this.$api.uploadtoken() // 刷新七牛token有效期
      const a = document.createElement('a')
      a.setAttribute('download', row.name)
      a.setAttribute('href', this.$qiniu.domain + row.url)
      a.click()
      // fetch(this.$qiniu.domain + row.url)
      //   .then((res) => res.blob())
      //   .then((blob) => {
      //     const link = document.createElement('a')
      //     link.setAttribute('download', row.name)
      //     link.setAttribute('href', URL.createObjectURL(blob))
      //     link.click()
      //   })
    },
    // 判断整数的二进制的第几位是否开关
    numtotitflog(num, i) {
      //  如7的四位二进制为0111（ 0111 = 0+4+2+1不考虑正负符号位）
      // 1左位移2位为0100（低位方向角标0起始的第2位为1，其他为0）
      // &（与）位算符操作，0111&0100,每一位分别对应判断同时为1可计一个值，结果只有0和1，如果值为1，说明num的二进制（0111）的第2位（低位方向角标0起始）是开（开/1,关/0）
      return (num & (1 << i)) != 0
    },
    // 二进制指定位取反
    getnumtotitflog(mun, i) {
      if (!this.numtotitflog(mun, i)) {
        return mun | (1 << i)
      } else {
        return mun & ~(1 << i)
      }
    },
    // 切换订阅设置
    async changebizMessageSub(mun) {
      this.tenantuserinfo.bizMessageSub = this.getnumtotitflog(this.tenantuserinfo.bizMessageSub, mun)
      await this.$api.bizmessagesub({ bizMessageSub: this.tenantuserinfo.bizMessageSub })
      localStorage.setItem('tenantuserinfo', JSON.stringify(this.tenantuserinfo))
    },
    // 微信解绑
    unbanld(item) {
      this.$confirm('正在解绑该微信账户, 是否继续?', '解绑微信', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.$api.wechatbindunbind(item.wechatUnionId)
        this.userinfo = await this.$api.getuserinfo(this.tenantinfo.tenantId, this.userinfo.userCode)
        localStorage.setItem('userinfo', JSON.stringify(this.userinfo))
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  width: 1200px;
  margin: 20px auto;
}
.card {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.card + .card {
  margin-top: 18px;
}
.cardtitle {
  padding: 12px 20px;
  color: black;
  background: ghostwhite;
}

.notice + .notice {
  margin-top: 20px;
}
.wxlist {
  .close {
    display: none;
  }
}
.wxlist:hover {
  .close {
    display: inherit;
  }
}
</style>
